import { OUTBOUND_LCF, RETURN_LCF } from "@app/constants/seat-selection-first";

import type { NavigationState } from "../../hooks/use-navigation";
import type { History } from "history";

import {
  CART_ID_KEY,
  OPEN_DRAWER_KEY,
  SEGMENT_ID_KEY,
  SELECTED_LEG_CARD_ID_KEY,
  SELECTED_SEATS_KEY,
  TRIP_ID_KEY,
  VIEW_KEY
} from "./constants";
import { PAGES } from "../../constants/pages";

export interface GoToOptions {
  force_refresh?: boolean;
  restart_spa_search?: boolean;
}

export class ResultsView {
  public static goTo(
    search_params: URLSearchParams,
    history: History<NavigationState>,
    state?: NavigationState,
    options: GoToOptions = {}
  ) {
    search_params.set(VIEW_KEY, PAGES.RESULTS);

    if (options.restart_spa_search) {
      search_params = this.removeSPAParams(search_params);
    }

    history.push({
      search: search_params.toString(),
      state: {
        ...state
      }
    });

    if (options.force_refresh) {
      history.go(0);
    }
  }

  public static removeSPAParams(search_params: URLSearchParams) {
    const async_cart_and_ssf_flow_keys = [
      OPEN_DRAWER_KEY,
      SEGMENT_ID_KEY,
      SELECTED_LEG_CARD_ID_KEY,
      OUTBOUND_LCF,
      RETURN_LCF,
      TRIP_ID_KEY,
      CART_ID_KEY,
      SELECTED_SEATS_KEY
    ];

    async_cart_and_ssf_flow_keys.forEach(key => search_params.delete(key));

    return search_params;
  }
}
